module.exports = __webpack_public_path__ + "static/media/chimene.5d1a1245.jpg";